import { render } from "./CourseAttendance.vue?vue&type=template&id=11d8c53e&ts=true"
import script from "./CourseAttendance.vue?vue&type=script&lang=ts"
export * from "./CourseAttendance.vue?vue&type=script&lang=ts"

import "./CourseAttendance.vue?vue&type=style&index=0&id=11d8c53e&lang=css"

import exportComponent from "/usr/local/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__